import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-107" data-mp="1mf2ctd0ek2u7">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-108" data-mp="1mgna3ae3pzvr">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-109" data-mp="1hnalv1dc3v3j">ACCESSO IMMEDIATO</p>
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-ochre/20 text-brand-ochre" data-id="element-110" data-mp="1wbf4k5ce06mb">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-111" data-mp="1rg85xbxz5s49" />
        </div>
        <h2 className="mb-12 text-3xl font-extrabold text-brand-blue md:text-4xl" data-id="element-112" data-mp="25d4z3k1kflob">⚡ Cosa Ottieni Subito?</h2>
        <div className="space-y-3 text-left" data-id="element-113" data-mp="20fd8ctcnq5lp">
          {instantAccessItems.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5" data-id="element-114" data-mp="azvti3c54kbc">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-green" aria-hidden="true" data-id="element-115" data-mp="62x3nwzieziy" />
              <span className="font-semibold" data-id="element-116" data-mp="2mzu72b6wayea">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-display text-2xl font-bold italic text-brand-red" data-id="element-117" data-mp="2ryf5c52l7803">
          Non rimarrai mai più senza materiale.
        </p>
      </Reveal>
    </section>;
}